import {MDIcon, MDIconSize} from '@mintdata-wsp/common/components/icon/MDIcon';
import {MDIcons} from '@mintdata-wsp/common/components/icon/MDIcons';
import {Spinner, SpinnerSize, SpinnerStyle, SpinnerWeight} from '@mintdata-wsp/common/components/spinner/Spinner';
import {Organization} from '@mintdata-wsp/common/state/DataState';
import {CopyPagesState} from '@mintdata-wsp/common/state/ui/visualDesigner/CopyPagesState';
import {controllers} from '@mintdata-wsp/wsp/controllers/WspControllers';
import {CustomDropdown} from '@mintdata-wsp/wsp/ui/components/customDropdown/CustomDropdown';
import bind from 'bind-decorator';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import * as React from 'react';

const styles = require('./OrganizationsDropdown.less');
const cx = classnames.bind(styles);

@observer
export class OrganizationsDropdown extends React.Component<any, any>
{
    @bind
    private _handleDropdownClick():void
    {
        const {copyPages} = controllers.ui;
        copyPages.loadOrganizationsAsync(true);
    }

    @bind
    private _getListItemClickHandler(org:Organization, closePopoverFunc:()=>void):(event:React.MouseEvent<any>) => void
    {
        return (event:React.MouseEvent<any>):any => {
            closePopoverFunc();
            controllers.ui.copyPages.onOrganizationSelected(org.siteId, org.name);
        };
    }

    @bind
    private _renderOrganizationsList(closePopoverFunc:()=>void):JSX.Element
    {
        const {copyPages} = controllers.ui;
        const copyState:CopyPagesState = copyPages.getState();
        const {organizations, selectedOrganizationSid, organizationsLoading} = copyState;

        return (
            <div className={cx('listWrapper')}>
                <div className={cx('listTitle')}>Organization</div>
                <div className={cx('list')}>
                    {organizationsLoading && <div
                        className={cx('spinnerWrapper')}
                    >
                        <Spinner
                            size={SpinnerSize.Large_32}
                            style={SpinnerStyle.Blue}
                            className={cx('spinner')}
                            weight={SpinnerWeight.Thin}
                        />
                    </div>
                    }

                    {!organizationsLoading && organizations.map((org:Organization) => (
                        <div
                            className={cx('listItem', {selected: org.siteId === selectedOrganizationSid})}
                            onClick={this._getListItemClickHandler(org, closePopoverFunc)}
                            key={org.siteId}
                        >
                            <div className={cx('iconWrapper')}>
                                <MDIcon className={cx('icon')}
                                        name={MDIcons.common.Business}
                                        size={MDIconSize.xlarge}
                                />
                            </div>
                            <div className={cx('info')}>
                                <p className={cx('name')}>{org.name}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    @bind
    private _renderTitle():JSX.Element
    {
        const {copyPages} = controllers.ui;
        const copyState:CopyPagesState = copyPages.getState();
        const {selectedOrganizationName} = copyState;

        return <div className={cx('titleWrapper')}>
            <MDIcon className={cx('icon')}
                    name={MDIcons.common.Business}
                    size={MDIconSize.medium16}
            />
            <span className={cx('title')}>{selectedOrganizationName}</span>
        </div>;
    }

    render():JSX.Element | false | null
    {
        return <CustomDropdown
            className={cx('base')}
            title={this._renderTitle()}
            renderListFunc={this._renderOrganizationsList}
            onClick={this._handleDropdownClick}
        />;
    }
}
